import useMenu from '@/hooks/useMenu'
import { ListItem } from '@/views/components/GuideRemind/js/type'
import { getGuideRemindConfig, finishIndexPageGuide, INDEX_PAGE_GUIDE_KEY } from './index-guide'
import { goto } from '..'
import { getRemindHtml } from '.'

const menuStore = useMenu()

/** 需要展示新手指引的菜单配置 */
export const GUIDE_REMIND_MENU_CONFIG_LIST = [
  {
    name: '入库记录',
    routePath: '/supply/warehouse/records',
    remindText: '查询供货订单入库记录、退货记录以及是否开票和结算'
  },
  {
    name: '供货记录',
    routePath: '/supply/record',
    remindText: '查询供货订单'
  },
  {
    name: '收货异常记录',
    routePath: '/supply/reject-record',
    remindText: '查询拒收和压损入库商品的原因、数量、图片等信息'
  }
]
/** 新的新手指引的初始步骤配置 */
export const INITIAL_STEP_CONFIG: ListItem = {
  selector: 'body',
  blankSelector: true,
  remindHtml: getRemindHtml(
    '全新体验，供应商平台重磅升级！',
    '为提供更高效的服务，乐药供应商服务平台已完成全面视觉与交互升级。告别繁琐的系统跳转，实现一站式业务闭环。让您的操作体验更流畅，经营数据更清晰。'
  ),
  isClipHighlight: false,
  positionY: 'top'
}
/** 新的新手指引的paycenter配置 */
export const PAYCENTER_CONFIG: ListItem = {
  selector: '.guide-menu-class-LeyoPayCenter',
  remindHtml: getRemindHtml(
    '实销实结结算入口',
    '原结算系统功能已迁移至此，无需再次选择结算系统进入',
    { maxWidth: 305 }
  ),
  isClipHighlight: true,
  positionY: 'top',
  scrollToView: true,
  spotPointLists: [
    {
      type: 'scale',
      xValue: 0.1,
      yValue: 0.1
    }
  ],
  beforeCurStepFun: async () => {
    let leyoPayCenter = document.querySelector('.guide-menu-class-LeyoPayCenter')
    if (leyoPayCenter) {
      leyoPayCenter.scrollIntoView({ behavior: 'auto', block: 'end' })
      const p = new Promise((resolve) => {
        setTimeout(() => {
          resolve(true)
        }, 60)
      })
      await p
    }
    leyoPayCenter = null
  }
}

/** 菜单指引的配置 */
export const getMenuGuideRemind = ({
  useFirstVisit = false, // 是否使用首次访问指引
  useNewbieGuide = false, // 是否使用新的新手指引
  usePaycenterGuide = false, // 是否使用实销实结结算入口指引
  useIndexGuide = false, // 是否使用首页指引
  isIndexPage = false // 是否是首页
}: Record<string, boolean> = {}) => {
  /** 过滤出有渲染的 */
  const renderConfigList = GUIDE_REMIND_MENU_CONFIG_LIST.filter((config) => {
    return menuStore.checkPathAvailable(config.routePath)
  })
  if (renderConfigList.length === 0) {
    return ''
  }
  let remindHtml = '<div style="font-size: 14px; line-height: 20px;">'
  renderConfigList.forEach((config) => {
    remindHtml = `${remindHtml}<div>${config.name}：${config.remindText}</div>`
  })
  remindHtml = `${remindHtml}</div>`
  const lists: ListItem[] = []
  if (useNewbieGuide) {
    lists.push(INITIAL_STEP_CONFIG)
  }
  if (useFirstVisit) {
    lists.push({
      selector: '.guide-menu-class-Supply',
      remindHtml,
      isClipHighlight: true,
      positionY: 'top',
      spotPointLists: [
        {
          type: 'scale',
          xValue: 0.1,
          yValue: 0.4
        }
      ]
    })
  }
  if (usePaycenterGuide) {
    lists.push(PAYCENTER_CONFIG)
  }

  let skipCallBackFun = useNewbieGuide
    ? finishIndexPageGuide
    : () => {
        //
      }
  let pageCompleteCallBackFun = () => {
    //
  }
  if (useIndexGuide) {
    if (isIndexPage) {
      const {
        skipCallBackFun: indexSkipCallBackFun,
        pageCompleteCallBackFun: indexPageCompleteCallBackFun,
        lists: indexLists
      } = getGuideRemindConfig()
      skipCallBackFun = indexSkipCallBackFun
      pageCompleteCallBackFun = indexPageCompleteCallBackFun
      lists.push(...indexLists)
    }
  }
  return {
    lists,
    skipCallBackFun: () => {
      if (typeof skipCallBackFun === 'function') {
        skipCallBackFun()
      }
    },
    pageCompleteCallBackFun: () => {
      if (useIndexGuide && !isIndexPage) {
        window?.localStorage.setItem(INDEX_PAGE_GUIDE_KEY, 'true')
        goto('IndexPageMain')
      } else {
        if (typeof pageCompleteCallBackFun === 'function') {
          pageCompleteCallBackFun()
        }
      }
    },
    isLastPage: !useIndexGuide || isIndexPage
  }
}
